module.exports = __webpack_public_path__ + "img/Billionaire-3.719aebd4.gif";